module.exports = __webpack_public_path__ + "officialStatic/img/product-olt.9d76782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-olt.png
// module id = WPKH
// module chunks = 0